export default {
  meta: {
    title: '门店地图',
    url: '/storemap', // 埋点用，记录所属模块
  },
};
